import type { SupportCenterSpecializationInput } from '../../types/supportCenterSpecialties'
import { daysInMonth } from './scheduleHelpers'

export const MODULE_NAME = 'central_amparo_parametros'
export const DEFAULT_MODULE_TITLE = 'Parâmetros'

export type ActiveTab =
  | 'usuarios'
  | 'especializacoes'
  | 'assistencias'
  | 'formularios'
  | 'indisponibilidade'
  | 'parametros'
  | 'motivos'
  | 'opcoes'

export type UserAssignmentRow = {
  user_id: string
  user_name: string
  specialization_names: string[]
  first_delegated_at: string
}

export type DateParts = { year: number; month: number; day: number }

export const EMPTY_SPEC_INPUT: SupportCenterSpecializationInput = {
  name: '',
  description: '',
  assistance_ids: [],
}

export function todayParts(): DateParts {
  const now = new Date()
  return { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() }
}

export function clampDay(parts: DateParts): DateParts {
  const max = daysInMonth(parts.year, parts.month)
  return { ...parts, day: Math.min(parts.day, max) }
}

export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString('pt-BR')
}

export function getErrorMessage(error: unknown): string {
  const maybe = error as { message?: string; code?: string; details?: string }
  const message = error instanceof Error ? error.message : maybe?.message
  const code = maybe?.code
  const blob = `${message ?? ''} ${maybe?.details ?? ''}`.toLowerCase()
  if (
    code === '23505' ||
    blob.includes('support_center_specialty_users_active_key') ||
    blob.includes('support_center_professional_users_active_key') ||
    blob.includes('support_center_specialization_users_active_key') ||
    blob.includes('duplicate key')
  ) {
    if (
      blob.includes('support_center_assistances_code_key') ||
      blob.includes('support_center_assistances_code_active_key')
    ) {
      return 'Já existe uma assistência com este código.'
    }
    if (
      blob.includes('support_center_forms_pkey') ||
      blob.includes('support_center_forms_form_key')
    ) {
      return 'Já existe um formulário com esta key.'
    }
    return 'Este profissional já possui uma ou mais das especialidades selecionadas.'
  }
  if (message) return message
  if (code) return `Erro (${code})`
  return 'Erro inesperado ao processar solicitação.'
}

export function buildYearOptions(): number[] {
  const current = new Date().getFullYear()
  return Array.from({ length: 6 }, (_, i) => current - 1 + i)
}
